module.exports = __webpack_public_path__ + "img/icon-feature-folder.67942853.svg";